import { AssignmentRequestType } from '../../features/client/request-client-dialog/request-client-dialog';
import { formatDateToDisplay } from './date.func';

export interface RequestClientMailData {
	assignmentType: AssignmentRequestType;
	date: Date;
	reason: string;
	currentProfessionalName: string;
	currentIfdName: string;
	targetProfessionalName?: string;
	targetIfdName?: string;
	transferLink: string;
}

export interface RequestClientMail {
	recipient: string;
	subject: string;
	body: string;
}

export function buildRequestClientMail(data: RequestClientMailData, recipient: string): RequestClientMail {
	if (data.assignmentType === AssignmentRequestType.Main) {
		return {
			recipient,
			subject: 'KlifdWeb: Antrag auf Verschieben eines Auftrags',
			body: buildMainAssignmentBody(data),
		};
	}

	return {
		recipient,
		subject: 'KlifdWeb: Antrag auf Erstellen eines FDS Auftrags',
		body: buildFdsAssignmentBody(data),
	};
}

function buildMainAssignmentBody(data: RequestClientMailData): string {
	return [
		'Hallo,',
		'',
		'der Anwender beantragt folgenden Fall zu verschieben:',
		`Verschiebedatum: ${formatDateToDisplay(data.date)}`,
		`Notiz: ${data.reason || '-'}`,
		'',
		`Abgebende Fachkraft: ${data.targetProfessionalName ?? '-'}`,
		`IFD: ${data.targetIfdName ?? '-'}`,
		'',
		`Annehmende Fachkraft: ${data.currentProfessionalName}`,
		`IFD: ${data.currentIfdName}`,
		'',
		`Link zur Verschiebeseite mit dem angefragten Klient: ${data.transferLink}`,
		'',
		'Mit freundlichen Grüssen',
		'Ihre KlifdWeb Anwenderverwaltung',
	].join('\n');
}

function buildFdsAssignmentBody(data: RequestClientMailData): string {
	return [
		'Hallo,',
		'',
		'der Anwender beantragt einen FDS Auftrag in seinem IFD eröffnet zu bekommen.',
		`Antragsdatum: ${formatDateToDisplay(data.date)}`,
		`Notiz: ${data.reason || '-'}`,
		'',
		`Anfragende Fachkraft: ${data.currentProfessionalName}`,
		`IFD: ${data.currentIfdName}`,
		'',
		`Link zur Verschiebeseite mit dem angefragten Klient: ${data.transferLink}`,
		'',
		'Mit freundlichen Grüssen',
		'Ihre KlifdWeb Anwenderverwaltung',
	].join('\n');
}

/**
 * Builds a safe mailto U with properly encoded subject and body.
 * Encodes special characters to prevent URL breakage (spaces, &, ?, etc.)
 */
export function buildMailto(recipient: string, subject: string, body: string): string {
	const encoded = (value: string) => encodeURIComponent(value ?? '');
	return `mailto:${encodeURIComponent(recipient)}?subject=${encoded(subject)}&body=${encoded(body)}`;
}
